import React, { FC, useEffect, useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";

import doddles from "../../assets/doddles.webp";
import Alert from "./alert/index.tsx";
import { useSelector } from "react-redux";

const Progress = styled(CircularProgress)(() => ({
  ".MuiCircularProgress-svg": {
    color: "white",
  },
}));

type Props = {
  children: React.ReactNode;
  verifyAuth?: boolean;
  isLogin?: boolean;
};

export const AppContainer: FC<Props> = ({
  children,
  verifyAuth = false,
  isLogin = false,
}) => {
  const session = useSelector((state: any) => state.session);
  const { isLoading } = useSelector((state: any) => state.appControl);

  const navigate = useNavigate();

  useEffect(() => {
    if (verifyAuth) {
      if (!session.token) {
        navigate("/login");
        return;
      }
    }
    if (isLogin && session.token) {
      navigate("/home");
    }
  }, [session]);

  return (
    <div className='flex justify-center items-center w-full h-full  max-w-[512px] bg-[rgb(23,43,69)]'>
      {isLoading && (
        <div className='absolute bg-black w-full h-[100dvh] flex justify-center items-center z-[60] opacity-40'>
          <Progress color='secondary' />
        </div>
      )}
      <Alert />

      <div className='h-full flex w-full z-40'>
        <div className='w-full h-full'>{children}</div>
      </div>

      <div
        className='absolute w-full h-[100dvh] max-w-[512px] z-0 repeat opacity-[0.035]'
        style={{ backgroundImage: `url(${doddles})` }}></div>
    </div>
  );
};
